// White-label brand store: loaded once from /api/public/branding (or the logged-in company) and read synchronously everywhere.
import { apiOrigin, getSite, previewHeaders } from './site';
const API = apiOrigin();
const DEFAULTS = {
  name: 'Print Shop', legal_name: '', tagline: '', headline: '', about: '', email: '', phone: '', website: '', address: {},
  primary_color: '#D90000', secondary_color: '#0A0A0A', accent_color: '#FFFFFF', logo_url: null, features: {}, terms_and_conditions: '',
  payments_enabled: true, slug: '', company_id: null,
};
let brand = { ...DEFAULTS };
const listeners = new Set();

const hexToRgb = (hex) => {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || '');
  return m ? `${parseInt(m[1], 16)}, ${parseInt(m[2], 16)}, ${parseInt(m[3], 16)}` : '217, 0, 0';
};

const applyTheme = () => {
  const root = document.documentElement;
  root.style.setProperty('--brand-primary', brand.primary_color);
  root.style.setProperty('--brand-primary-rgb', hexToRgb(brand.primary_color));
  root.style.setProperty('--brand-secondary', brand.secondary_color);
  root.style.setProperty('--brand-accent', brand.accent_color);
  document.title = brand.is_platform ? brand.name : `${brand.name} | Proposal Builder`;
  let el = document.getElementById('brand-theme');
  if (!el) { el = document.createElement('style'); el.id = 'brand-theme'; document.head.appendChild(el); }
  // Remap the legacy hard-coded Tailwind brand classes to the tenant's colors.
  el.textContent = `
    .bg-\\[\\#D90000\\]{background-color:var(--brand-primary)!important}
    .hover\\:bg-\\[\\#D90000\\]:hover{background-color:var(--brand-primary)!important}
    .text-\\[\\#D90000\\]{color:var(--brand-primary)!important}
    .hover\\:text-\\[\\#D90000\\]:hover{color:var(--brand-primary)!important}
    .border-\\[\\#D90000\\]{border-color:var(--brand-primary)!important}
    .bg-\\[\\#0A0A0A\\]{background-color:var(--brand-secondary)!important}
    .bg-\\[\\#B00000\\]{background-color:var(--brand-primary)!important;filter:brightness(.85)}
  `;
};

export const setBrand = (b) => {
  brand = { ...DEFAULTS, ...(b || {}) };
  window.__BRAND__ = brand;
  applyTheme();
  listeners.forEach((fn) => fn(brand));
};
export const subscribeBrand = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };
export const getBrand = () => brand;
export const brandName = () => brand.name || DEFAULTS.name;
export const brandEmail = () => brand.email || '';
export const brandPhone = () => brand.phone || '';
export const brandWebsite = () => (brand.website || '').replace(/^https?:\/\//, '');
export const brandLogo = () => (brand.logo_url ? `${API}${brand.logo_url}` : null);
export const brandFeature = (name) => brand.features?.[name] !== false;

export const loadPublicBrand = async () => {
  const site = getSite();
  if (site.mode === 'storefront' && site.company) { setBrand(site.company); return site.company; }
  const params = new URLSearchParams(window.location.search);
  const slug = site.mode === 'combined' ? (params.get('company') || localStorage.getItem('brand_slug')) : null;
  const url = `${API}/api/public/branding${slug ? `?company=${encodeURIComponent(slug)}` : ''}`;
  try {
    const r = await fetch(url, { headers: previewHeaders() });
    if (r.ok) {
      const data = await r.json();
      if (params.get('company')) localStorage.setItem('brand_slug', params.get('company'));
      setBrand(data);
      return data;
    }
  } catch (e) { /* offline: keep defaults */ }
  setBrand(brand);
  return brand;
};
